import { Button } from 'reactstrap';

import styled, { css } from 'styled-components';

const isOutlined = css`
  background: #ffffff;
  border: 1px solid #dfe3ec;
`;

const alignLeft = css`
  margin: 0 auto 0 0 !important;
`;

const shared = css`
  padding: 12px 16px;
  font-weight: normal;
  ${({ outline }) => outline && isOutlined};
  ${({ left }) => left && alignLeft}
`;

const sharedMargin = css`
  margin: 0 0 0 8px !important;
`;

export const StyledModalConfirmButton = styled(Button)`
  margin: 0 8px 0 0 !important;
  ${shared};
`;

export const StyledModalCancelButton = styled(Button)`
  ${sharedMargin};
  ${shared};
  color: #33373d;
`;

export default {
  StyledModalConfirmButton,
  StyledModalCancelButton
};
